import React from 'react';

import { FormattedMessage } from 'react-intl-next';

import { LinkButton } from '@atlaskit/button/new';
import { JiraIcon } from '@atlaskit/logo';
import { Inline } from '@atlaskit/primitives/compiled';

import { messages } from './messages';

export const ViewAllButton = (props: {
	totalIssuesCount: number;
	url: string;
	callback: () => void;
}): React.JSX.Element => {
	const { totalIssuesCount, url, callback } = props;

	return (
		<LinkButton href={url} appearance="default" onClick={callback} testId="view-all-button">
			<Inline space="space.075" alignBlock="center" alignInline="center">
				<JiraIcon appearance="brand" shouldUseNewLogoDesign size="xxsmall" />
				<FormattedMessage {...messages.viewAll} values={{ totalCount: totalIssuesCount }} />
			</Inline>
		</LinkButton>
	);
};
